/**
 * Schiff-Stats im Flotten-Tab (unten rechts).
 */
import type { ShipTypeDef } from '../config/ShipTypes';
import { formatTime } from './BuildingCardTimer';

const WRAP_STYLE =
  'background:rgba(0,0,0,0.55);backdrop-filter:blur(10px);' +
  'border:1px solid rgba(136,204,255,0.35);border-radius:10px;' +
  'padding:clamp(10px,2vw,18px);font-family:monospace;font-size:clamp(10px,2.4vw,12px);' +
  'color:#8cf;min-width:clamp(140px,25vw,200px);' +
  'box-shadow:0 4px 20px rgba(0,0,0,0.4);';

const ROW_STYLE = 'display:flex;justify-content:space-between;gap:clamp(8px,2vw,14px);margin-bottom:6px;';
const LBL_STYLE = 'color:#6a8a9a;';
const VAL_STYLE = 'color:#bdf;';

function buildRows(def: ShipTypeDef): [string, string][] {
  const transport = def.warpCarry
    ? (() => { const s = def.warpCarry!.reduce((a, b) => a + b, 0); return s > 0 ? `${s} Einheiten` : '—'; })()
    : '—';
  return [
    ['Bauzeit', formatTime(def.buildTime)],
    ['DMG/s', '—'],
    ['Hülle', '—'],
    ['Warp Haken', '—/X'],
    ['Reichweite', 'Standard'],
    ['Warpgeschwindigkeit', '—'],
    ['Geschwindigkeit', def.speed.toFixed(1)],
    ['Warp-fähig', def.warpCapable ? 'Ja' : 'Nein'],
    ['Footprint', def.footprint.toFixed(2)],
    ['Transport', transport],
  ];
}

export function createFleetTabStats(def: ShipTypeDef): HTMLDivElement {
  const wrap = document.createElement('div');
  wrap.style.cssText = WRAP_STYLE;
  for (const [lbl, val] of buildRows(def)) {
    const row = document.createElement('div');
    row.style.cssText = ROW_STYLE;
    row.innerHTML = `<span style="${LBL_STYLE}">${lbl}</span><span style="${VAL_STYLE}">${val}</span>`;
    wrap.appendChild(row);
  }
  return wrap;
}

export function updateFleetTabStats(el: HTMLDivElement, def: ShipTypeDef): void {
  el.innerHTML = '';
  for (const [lbl, val] of buildRows(def)) {
    const row = document.createElement('div');
    row.style.cssText = ROW_STYLE;
    row.innerHTML = `<span style="${LBL_STYLE}">${lbl}</span><span style="${VAL_STYLE}">${val}</span>`;
    el.appendChild(row);
  }
}
